/**
 * Utilities pour accéder aux variables d'environnement au runtime
 */

declare global {
  interface Window {
    __ENV_CONFIG__: Record<string, any>;
  }
}

/**
 * Récupère une variable d'environnement
 * Utilise d'abord la valeur du runtime (modifiable par PHP) si elle existe,
 * sinon utilise la valeur au moment du build (process.env)
 * 
 * @param key Nom de la variable d'environnement (préfixée par GATSBY_)
 * @param defaultValue Valeur par défaut si la variable n'existe pas
 * @returns Valeur de la variable d'environnement
 */
export const getEnv = (key: string, defaultValue: string = ''): string => {
  // Vérifier si on est côté navigateur
  if (typeof window !== 'undefined') {
    // Vérifier si la configuration runtime existe
    if (window.__ENV_CONFIG__ && window.__ENV_CONFIG__[key] !== undefined) {
      return window.__ENV_CONFIG__[key];
    }
  }

  // Fallback sur les variables d'environnement statiques (build-time)
  // @ts-ignore
  return process.env[key] || defaultValue;
};

/**
 * Récupère toutes les variables d'environnement disponibles
 * 
 * @returns Objet contenant toutes les variables d'environnement
 */
export const getAllEnvVars = (): Record<string, any> => {
  if (typeof window !== 'undefined' && window.__ENV_CONFIG__) {
    return window.__ENV_CONFIG__;
  }
  
  // Fallback sur les variables d'environnement statiques (build-time)
  // @ts-ignore
  return process.env;
};

/**
 * Vérifie si une variable d'environnement existe
 * 
 * @param key Nom de la variable d'environnement
 * @returns true si la variable existe
 */
export const hasEnv = (key: string): boolean => {
  if (typeof window !== 'undefined' && window.__ENV_CONFIG__) {
    return window.__ENV_CONFIG__[key] !== undefined;
  }
  
  // @ts-ignore
  return process.env[key] !== undefined;
}; 